module.exports = __webpack_public_path__ + "static/logo-816a2ba865b6be93b795b709e3dfc19d.svg";